import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { CategoryGroup, Job, JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const jobAttributesAdapter = createEntityAdapter<JSONApiDataObject<CategoryGroup>>({
  selectId: item => item.id
});

export const jobAttributesSlice = createSlice({
  name: 'jobAttributes',
  initialState: jobAttributesAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<Job>>),
  reducers: {
    jobAttributesAdded: (state, action) => {
      jobAttributesAdapter.setMany(state, action.payload);
    }
  }
});

export const jobAttributesSelectors = jobAttributesAdapter.getSelectors((state: RootState) => state.jobAttributes);
